import { AnonymizerTaskReference } from './anonymizer-task';

export function anonymizerTaskStatusLabel(task: AnonymizerTaskReference): string {
  if (task.isFinished) return 'Kész';
  switch (task.status) {
    case 'awaiting_sync': return 'Szinkronizálásra vár';
    case 'sync_failed': return 'Szinkronizálás sikertelen';
    case 'expired': return 'Az eredmény lejárt';
    default: return task.isAnonymizationFinished ? 'Szinkronizálásra vár' : `Anonimizálás: ${task.progress}%`;
  }
}

export function anonymizerTaskStatusDescription(task: AnonymizerTaskReference): string {
  switch (task.status) {
    case 'awaiting_sync': return 'Az anonimizálás elkészült. A videó még nem került az útvonalhoz; indíts szinkronizálást.';
    case 'sync_failed': return 'A videó átvitele nem sikerült. A naplók ellenőrzése után próbáld újra a szinkronizálást.';
    case 'expired': return 'Az anonimizáló törölte a lejárt eredményt. Új anonimizálás szükséges, ha még nincs megfelelő videó az útvonalhoz.';
    case 'finished': return 'A videó szinkronizálva és az útvonalhoz csatolva.';
    default: return '';
  }
}
